var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCuratedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 42.6666C37.3333 47.3866 35.2799 51.6532 31.9999 54.5599C29.1733 57.1199 25.4399 58.6666 21.3333 58.6666C12.5066 58.6666 5.33325 51.4932 5.33325 42.6666C5.33325 35.3066 10.3466 29.0666 17.1199 27.2266C18.9599 31.8666 22.9066 35.4399 27.7866 36.7732C29.1199 37.1466 30.5333 37.3332 31.9999 37.3332C33.4666 37.3332 34.8799 37.1466 36.2133 36.7732C36.9333 38.5866 37.3333 40.5866 37.3333 42.6666Z",
    stroke: "#046242",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 21.3334C48 23.4134 47.6 25.4134 46.88 27.2267C45.04 31.8667 41.0933 35.44 36.2133 36.7734C34.88 37.1467 33.4667 37.3334 32 37.3334C30.5333 37.3334 29.12 37.1467 27.7867 36.7734C22.9067 35.44 18.96 31.8667 17.12 27.2267C16.4 25.4134 16 23.4134 16 21.3334C16 12.5067 23.1733 5.33337 32 5.33337C40.8267 5.33337 48 12.5067 48 21.3334Z",
    stroke: "#046242",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6667 42.6666C58.6667 51.4932 51.4933 58.6666 42.6667 58.6666C38.56 58.6666 34.8267 57.1199 32 54.5599C35.28 51.6532 37.3333 47.3866 37.3333 42.6666C37.3333 40.5866 36.9333 38.5866 36.2133 36.7732C41.0933 35.4399 45.04 31.8666 46.88 27.2266C53.6533 29.0666 58.6667 35.3066 58.6667 42.6666Z",
    stroke: "#046242",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuratedIcon);
export default __webpack_public_path__ + "static/media/curated-icon.587c3574bc536bf2ea9ac92e9da58c4b.svg";
export { ForwardRef as ReactComponent };